import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import { getAccountScopeUserSettings } from 'owa-session-store';
import getAggregatePolicyInfo from './utils/getAggregatePolicyInfo';
import { isGlobalFeatureEnabled, isAccountFeatureEnabled } from 'owa-feature-flags';
import {
    DiagnosticsFeature,
    getAggregateFeedbackSupportFeatureFlag,
} from './utils/getAggregateFeedbackSupportFeatureFlag';
import { isLocaleAvailable } from './utils/isLocaleAvailable';
import { logUsage } from 'owa-analytics';
import { getCurrentLanguage } from 'owa-localize';

export { isTenantCloudSupportedForFeedback } from './utils/isTenantCloudSupportedForFeedback';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const diagnosticsFeedbackCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        const policies = getAggregatePolicyInfo('isFeedbackEnabled');
        const isfeedbackPolicyEnabled = policies['isFeedbackEnabled'] as boolean;
        const { IsConsumerChild } = getAccountScopeUserSettings(
            mailboxInfo ?? getModuleContextMailboxInfo()
        );
        const isFeedbackEnabledByPolicy = isfeedbackPolicyEnabled;
        const isLocaleAvailableForFeedback = isGlobalFeatureEnabled('mon-diag-localesLookup')
            ? isLocaleAvailable()
            : true;

        logUsage(
            'DiagnosticsAndSupport_Capabilities',
            mailboxInfo ?? getModuleContextMailboxInfo(),
            {
                capabilityName: 'Feedback',
                isFeedbackEnabled: isAccountFeatureEnabled(
                    'mon-diag-feedbackjs',
                    getGlobalSettingsAccountMailboxInfo()
                ),
                isFeedbackPolicyEnabled: isfeedbackPolicyEnabled,
                currentLanguage: getCurrentLanguage(),
                isLocaleAvailable: isLocaleAvailable(),
            },
            { sessionSampleRate: 1 }
        );

        return (
            !IsConsumerChild &&
            isFeedbackEnabledByPolicy &&
            getAggregateFeedbackSupportFeatureFlag(DiagnosticsFeature.Feedback) &&
            isLocaleAvailableForFeedback
        );
    },
};
